import React, { useEffect, useRef } from 'react';

import config from '../config';
import Icon from '../components/icon';

function SigninGoogle({ onSubmit }) {
	const buttonRef = useRef(null);

	// load and init google fedcm script (or set access token on callback)
	useEffect(() => {
		const hashParams = new URLSearchParams(window.location.hash.substring(1));
		const accessToken = hashParams.get('access_token');

		// is callback call (not in use?)
		if (accessToken) {
			onSubmit({
				type: 'token',
				credentials: {issuer: 'google', token: accessToken},
			});

			return;
		}

		// is fedcm not available
		if (!window.navigator?.credentials) {
			return;
		}

		// TODO reserved
		// try to load token (stored on device)
		// https://developer.mozilla.org/en-US/docs/Web/API/FedCM_API/RP_sign-in
		// const credential = await navigator.credentials.get({identity: {
		// 	context: 'signin',
		// 	providers: [{
		// 		configURL: 'https://accounts.google.com/gsi/fedcm.json',
		// 		clientId: config.services.google.clientId,
		// 		mode: 'passive',
		// 		params: {
		// 			nonce: crypto.randomUUID?.() || Math.random().toString(36).substring(2),
		// 		},
		// 	}],
		// }}).catch();
		//
		// if (credential?.token) {
		// 	onSubmit({
		// 		type: 'token',
		// 		credentials: {issuer: 'google', token: credential.token},
		// 	});
		//
		// 	return;
		// }

		const script = document.createElement('script');
		script.src = 'https://accounts.google.com/gsi/client';
		script.async = true;
		script.defer = true;

		script.onload = () => {
			// https://developers.google.com/identity/gsi/web/reference/js-reference#google.accounts.id.initialize
			window.google.accounts.id.initialize({
				client_id: config.services.google.clientId,
				use_fedcm_for_button: true, // experimental: falls back automatically?
				// obsoleted / use_fedcm_for_button: false,
				// obsoleted / ux_mode: 'redirect'
				callback: ({ credential }) => {
					// arg example:
					// {
					//   clientId: 'xxx',
					//   client_id: 'xxx',
					//   credential: 'yyy',
					//   select_by: 'btn'
					// }
					onSubmit({
						type: 'token',
						credentials: {issuer: 'google', token: credential},
					});
				}
			});

			// https://developers.google.com/identity/gsi/web/reference/js-reference#GsiButtonConfiguration
			window.google.accounts.id.renderButton(buttonRef.current, {type: 'icon'});
		};

		document.body.appendChild(script);

		return () => {
			window.google?.accounts.id.cancel();
			document.body.removeChild(script);
		};
	}, [buttonRef.current]);

	return (
		<div className="d-grid">
			<div ref={buttonRef} id="google-button" style={{display: 'none'}} />
			<a
				className="btn btn-outline-dark"
				onClick={() => buttonRef.current.querySelector('div[role=button]').click()}
			>
				<span className="pe-2"><Icon.Google /></span>
				<span>Continue with Google</span>
			</a>
		</div>
	);
}

export default SigninGoogle;
